import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ellipsis'
})
export class EllipsisPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    const length = Number(args) || 20;
    return value && value.length > length
      ? value.substr(0, length) + '...'
      : value;
  }
}
